<div class="modal-header">
  <h4 class="modal-title" id="update-attr-modal-basic-title">
    {{ modalTitle }}
  </h4>
  <button
    id="cisterna-details-update-attr-modal-close"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="d('Cross')"
  ></button>
</div>
<div class="modal-body">
  <p>
    <strong>{{ modalQuestion }}</strong>
  </p>
  <p>{{ modalMessage }}</p>
  <form [formGroup]="attributeForm">
    <div class="container-fluid">
      <div class="row my-2">
        <div
          *ngIf="attributeToChange === 'SECCertificate'"
          id="cisterna-SECCertificate"
          class="col-sm"
        >
          <label
            id="cisterna-SECCertificate-text"
            for="SECCertificate"
            class="form-label"
            >N° certificado SEC <span class="text-danger fs-4">*</span></label
          >
          <div class="form-group">
            <input
              type="number"
              id="cisterna-SECCertificate-input"
              formControlName="SECCertificate"
              class="form-control immutable-field"
              placeholder="Ejemplo: 345678901234567"
              appInputTrim
            />
          </div>
        </div>
        <div
          *ngIf="attributeToChange === 'SECDate'"
          id="cisterna-SECDate"
          class="col-sm"
        >
          <label id="cisterna-SECDate-text" for="SECDate" class="form-label"
            >Fecha de inscripción SEC<span class="text-danger fs-4"
              >*</span
            ></label
          >
          <div class="form-group">
            <input
              type="date"
              id="cisterna-SECDate"
              max="{{ maxDate }}"
              formControlName="SECDate"
              class="form-control"
            />
            <ng-container
              *ngIf="
                attributeForm.controls['SECDate'].hasError('futureDate') &&
                attributeForm.controls['SECDate'].touched
              "
            >
              <span
                >{{ attributeForm.controls['SECDate'].errors?.['futureDate'] }}</span
              >
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="attributeToChange === 'SECFolio'" class="container-fluid">
      <div class="row my-2">
        <div id="cisterna-SECFolio" class="col-sm">
          <label id="cisterna-SECFolio-text" for="SECFolio" class="form-label"
            >N° Folio inscripción SEC<span class="text-danger fs-4"
              >*</span
            ></label
          >
          <div class="form-group">
            <input
              type="number"
              id="cisterna-SECFolio-input"
              formControlName="SECFolio"
              class="form-control immutable-field"
              placeholder="Ejemplo: 234567890123456"
              appInputTrim
            />
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    id="cisterna-details-update-attr-modal-cancel"
    type="button"
    class="btn btn-outline-danger-new"
    (click)="d('Cancel')"
  >
    Cancelar
  </button>
  <button
    id="cisterna-details-update-attr-modal-accept"
    type="button"
    class="btn btn-outline-primary-new"
    (click)="c('Accept')"
    [disabled]="!attributeForm.valid"
  >
    Aceptar
  </button>
</div>
